import { Flex, Loader, Text } from "@mantine/core";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

// Same pattern as de-payment-admin: Golomt/OAuth redirect lands here, notify the
// opener, then close so buyer-invoice pay can finish (poll + alert).
export function BankCallback() {
  const { t } = useTranslation("common");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const payload: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      payload[key] = value;
    });

    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: "BANK_AUTH_DONE", payload },
          window.location.origin,
        );
      }
    } catch {
      // cross-origin or missing opener — ignore
    }

    const timer = setTimeout(() => {
      window.close();
    }, 300);

    return () => clearTimeout(timer);
  }, [searchParams]);

  return (
    <Flex mih="100vh" direction="column" align="center" justify="center" gap="md">
      <Loader color="brand" />
      <Text size="sm" c="var(--mantine-color-gray-8)">
        {t("bankVerifySuccess")}
      </Text>
    </Flex>
  );
}

export default BankCallback;
